import React, { useEffect } from "react";
import FooterNew from "../components/Footer-New.js";
import Navbar from "../components/Navbar.js";
import NavbarFixed from "../components/Navbar-Fixed.js";

// import components
import ResetPassword from '../components/ResetPassword';



export default function ResetPassPage(props) {
  return (
    <div>

      <Navbar />
      <div className="innerpages_wrapper">
        <div className="auth_wrapper">
          <ResetPassword />
        </div>
      </div>
      <FooterNew/>
      {/* <NavbarFixed /> */}
    </div>
  );
}